
export default function HistorySection() {
  const milestones = [
    {
      year: "2018",
      title: "Academy Founded",
      description: "NextZen Soccer Academy was established in Folsom, CA with a vision to provide world-class soccer training for young athletes."
    },
    {
      year: "2019",
      title: "First Championship",
      description: "Our U-12 team won their first regional championship, marking the beginning of our competitive success."
    },
    {
      year: "2020",
      title: "Facility Expansion",
      description: "Expanded our training facilities to include two additional fields and a state-of-the-art indoor training center."
    },
    {
      year: "2021",
      title: "500+ Players",
      description: "Reached a milestone of training over 500 young athletes across all age groups and skill levels."
    },
    {
      year: "2022",
      title: "Elite Program Launch",
      description: "Launched our Elite Development Program for advanced players seeking collegiate and professional opportunities."
    },
    {
      year: "2023",
      title: "Community Impact",
      description: "Established scholarship programs and community outreach initiatives, making soccer accessible to all families."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Journey</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From humble beginnings to becoming Folsom's premier soccer academy, our story is one of dedication, growth, and unwavering commitment to excellence.
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-purple-200"></div>
          
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div key={milestone.year} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                  <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-purple-500">
                    <div className="text-2xl font-bold text-purple-600 mb-2">{milestone.year}</div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{milestone.title}</h3>
                    <p className="text-gray-700">{milestone.description}</p>
                  </div>
                </div>
                
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center">
                    <i className="ri-football-line text-white text-xl"></i>
                  </div>
                </div>
                
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
